import React from 'react'

const UniversityDashboard = () => {
  return (
    <div>UniversityDashboard</div>
  )
}

export default UniversityDashboard